import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, TecnologieDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { TecnologieHubTemplate } from '@components/templates'

const TecnologieHub = ({ pagina, tecnologie }) => (
  <TecnologieHubTemplate pagina={pagina} tecnologie={tecnologie} />
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'tecnologie', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { tecnologie },
    } = await client.query({
      query: TecnologieDocument,
    })

    return {
      props: { pagina, tecnologie },
      revalidate: 60 * 20,
    }
  },
  '/azienda/tecnologie'
)

export default TecnologieHub
